<template>
  <div :class="[`fw-filterelem-filter`, `fw-filterelem-filter-text`]">
    <div class="fw-filterelem-filter-content">
      <PrimeVueInputText
        v-model="localValue"
        :placeholder="props.placeholder ?? `Suchbegriff eingeben`"
        @keyup.enter="applyFilter"
      />
    </div>
    <div class="fw-filterelem-filter-actions">
      <PrimeVueButton class="action-save" @click="applyFilter">
        {{ languageStrings.apply[languageStore.language] }}
      </PrimeVueButton>
      <Transition name="filterpel-fade">
        <PrimeVueButton v-if="localValue" class="action-clear p-button-secondary" @click="clearFilter">
          {{ languageStrings.reset[languageStore.language] }}
        </PrimeVueButton>
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';

import { default as PrimeVueInputText } from 'primevue/inputtext';
import { default as PrimeVueButton } from 'primevue/button';

import useLanguageStore from "@/stores/language";

// define props & emits
const props = defineProps<{
  modelValue: unknown,
  placeholder?: string,
}>();
const emit = defineEmits<{
  "update:modelValue": [value: string | undefined]
  "applyFilter": [value: string]
  "clearFilter": []
  "closeDropdown": []
}>();

// define stores
const languageStore = useLanguageStore();

// define language strings
const languageStrings: ILanguageStrings = {
  apply: {
    de: "Anwenden",
    en: "Apply"
  },
  reset: {
    de: "Zurücksetzen",
    en: "Reset"
  }
};

// define value
const localValue = ref('');
watch(() => props.modelValue, (newValue) => {
  localValue.value = newValue ? String(newValue) : '';
});
onMounted(() => {
  localValue.value = props.modelValue ? String(props.modelValue) : '';
});

// on submit change model value
const applyFilter = () => {
  // if empty, clear and close dropdown
  if (localValue.value === '') {
    clearFilter();
    closeDropdown();
    return;
  }

  // else submit new values
  emit("update:modelValue", localValue.value);
  emit("applyFilter", localValue.value);
};

// on clear reset model value
const clearFilter = () => {
  localValue.value = '';
  emit("update:modelValue", undefined);
  emit("clearFilter");
  closeDropdown();
};

// close dropdown
const closeDropdown = () => {
  emit("closeDropdown");
};

</script>
